import React, { useEffect } from "react";
import Maincomponent from "./routes/MainRoute";
import "./App.scss";
import Login from "./module/AuthModule/Login";
import AgentLogin from "./agentModule/authModule/Login";
import Cookies from "js-cookie";
import { TOKEN } from "./utility/constant";

const App = () => {
  const hasToken = !!Cookies.get(TOKEN);
  const userRole = Cookies.get("USER_ROLE");
  const userName = Cookies.get("USER_NAME");

  useEffect(() => {
    // Set dynamic page title based on authentication status
    if (hasToken) {
      document.title = `INXT Broker Suite - Dashboard | ${userName || 'User'}`;
    } else {
      document.title = "INXT Broker Suite - Login | Insurance Broker Management";
    }

    // Update meta tags for authenticated pages
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      if (hasToken) {
        metaDescription.content = "INXT Broker Suite Dashboard - Manage insurance policies, process claims, generate quotes, and track client information in one comprehensive platform.";
      } else {
        metaDescription.content = "Login to INXT Broker Suite - Secure access to your insurance broker management platform. Manage policies, claims, and clients efficiently.";
      }
    }
  }, [hasToken, userName]);

  console.log(hasToken, "hasToken");

  return (
    <div className="App">
      {/* master login*/}
      {/* <Login /> */}
      {/* AgentLogin */}
      {hasToken ? <Maincomponent /> : <AgentLogin />}
    </div>
  );
};

export default App;
